import { connect } from 'react-redux';

import BaseComponent from '../../components/BaseComponent';
import { resumesConfig } from '../../entity/CMS/resumesConfig';

class Resumes extends BaseComponent {
  constructor(props) {
    super(props);
    this.config = { ...resumesConfig };
    this.getResponse();
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(Resumes);
